<template>
  <div class="upload-container">
    <el-button :style="{ background: color, borderColor: color }" icon="el-icon-upload" size="mini" type="primary"
      @click="dialogVisible = true">上传图片
    </el-button>
    <el-dialog :visible.sync="dialogVisible" :append-to-body='true'>
      <el-upload :multiple="true" :file-list="fileList" :show-file-list="true" :on-remove="handleRemove"
        :on-success="handleSuccess" :before-upload="beforeUpload" class="editor-slide-upload" :action="actionPath"
        :data="postData" list-type="picture-card">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getQiniuToken, getAliParams } from '@/api/common'
import { guid } from '@/utils/index'

export default {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  },
  data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: [],
      actionPath: '',
      baseUrl: '',
      postData: {
        key: ''
      },
      domain: '',
      expire: '',
      keyList: {}
    }
  },
  async mounted() {
    // getQiniuToken().then(response => {
    //   console.log(response);
    //   this.actionPath = response.data.uploadUrl
    //   this.baseUrl = response.data.baseUrl
    //   this.postData.token = response.data.token
    // })

    try {
      let res = await getAliParams()
      const { OSSAccessKeyId, domaind, host, policy, signature, expire } = res.data
      this.actionPath = host
      this.baseUrl = domaind
      this.postData = { OSSAccessKeyId, policy, signature }
      this.expire = expire
      console.log('获取到值', res)
    } catch (err) {
      console.log('获取失败', err)
    }
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
    },
    handleSubmit() {
      const arr = Object.keys(this.listObj).map(v => this.listObj[v])
      if (!this.checkAllSuccess()) {
        this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return
      }
      console.log(arr)
      this.$emit('successCBK', arr)
      this.listObj = {}
      this.fileList = []
      this.dialogVisible = false
    },
    handleSuccess(response, file) {
      console.log('res', response);
      console.log('file', file);
      const uid = file.uid
      console.log(this.postData.key)
      const objKeyArr = Object.keys(this.listObj)
      console.log('objKeyArr', objKeyArr);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = this.baseUrl + this.keyList[uid]
          this.listObj[objKeyArr[i]].hasSuccess = true
          console.log(this.baseUrl + this.keyList[uid]);
          console.log(this.listObj);
          return
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]]
          return
        }
      }
    },
    beforeUpload(file) {
      console.log(Date.now(), this.expire * 1000)
      if (file.type !== "image/png" && file.type !== "image/jpeg") {
        this.$message({
          message: '请上传图片类型',
          type: 'warning'
        });
        return false
      }
      if (Date.now() > this.expire * 1000) {
        this.$message({
          message: '上传凭证已过期请刷新页面重新获取',
          type: "warning"
        })
        return false
      }
      console.log('1312312312312312asdasdas')
      const _self = this
      const _URL = window.URL || window.webkitURL
      const fileName = file.uid
      this.postData.key = guid() + '.' + file.type.split('/')[1]
      this.keyList[fileName] = this.postData.key
      console.log('-----', this.postData.key)
      this.listObj[fileName] = {}
      const img = new Image()
      img.src = _URL.createObjectURL(file)
      img.onload = function () {
        _self.listObj[fileName] = { hasSuccess: false, uid: file.uid, width: this.width, height: this.height }
      }
      // return new Promise((resolve, reject) => {
      //   const img = new Image()
      //   img.src = _URL.createObjectURL(file)
      //   img.onload = function() {
      //     _self.listObj[fileName] = { hasSuccess: false, uid: file.uid, width: this.width, height: this.height }
      //   }
      //   resolve(true)
      // })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;

  .el-upload--picture-card {
    width: 100%;
  }
}
</style>
